import DashboardItem, { proseClasses } from './dashboard-item';
import { htmlSafe } from '@ember/template';

export default class Summary extends DashboardItem {
  <template>
    <div class={{proseClasses}}>
      {{htmlSafe @componentDefinition.text}}
    </div>
  </template>
}
